import { render, staticRenderFns } from "./SegmentInterest.vue?vue&type=template&id=6956f624&"
import script from "./SegmentInterest.vue?vue&type=script&lang=js&"
export * from "./SegmentInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports